import postAPI from './postAPI.js'

export default async function postArchiveTaskFlow(id) {
    const data = await postAPI('admin/taskflows/archive', { id });
    return data;
}
